import { defineMessages } from 'react-intl'

const scope = `procurify.components.RequestableCreditCardSelect`

export default defineMessages({
  placeholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'Select a payment method',
  },
  endingIn: {
    id: `${scope}.endingIn`,
    defaultMessage: 'ending in {cardNumber}',
  },
  otherName: {
    id: `${scope}.otherName`,
    defaultMessage: 'Other',
  },
  otherDescription: {
    id: `${scope}.otherDescription`,
    defaultMessage: 'eg: Cash, Misc',
  },
  loadErrorTitle: {
    id: `${scope}.loadErrorTitle`,
    defaultMessage: 'Error',
  },
  loadErrorMessage: {
    id: `${scope}.loadErrorMessage`,
    defaultMessage: 'Failed to load payment methods. Please try again.',
  },
})
